import { ErrorHandler } from '@sketch/tracing'

export interface FormatPriceOptions {
  trimDecimalIfZero?: boolean
}

const dollarFormat = new Intl.NumberFormat(['en'], {
  style: 'currency',
  currency: 'usd',
  minimumFractionDigits: 2,
})

export const formatPrice = (
  value: number,
  { trimDecimalIfZero = true }: FormatPriceOptions = {}
) => {
  const valueFormatted = dollarFormat.format(value)
  return trimDecimalIfZero
    ? valueFormatted.replace(/\D00$/, '')
    : valueFormatted
}

export const formatPriceShort = (
  value: string | number,
  options?: FormatPriceOptions
) => formatPrice(parseInt(value as string, 10) / 100, options)

const safeguardNumberFormat = (
  priceInFull: number,
  currency: string,
  trimDecimalIfZero: boolean = false
) => {
  try {
    return new Intl.NumberFormat(currency !== 'USD' ? 'de-DE' : 'en', {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      trailingZeroDisplay: trimDecimalIfZero ? 'stripIfInteger' : 'auto',
    }).format(priceInFull)
  } catch (e) {
    ErrorHandler.shouldNeverHappen(`There's an issue formatting a price ${e}`)

    return dollarFormat.format(priceInFull)
  }
}

export const formatPriceWithCurrency = (
  value: number,
  currency: string,
  { trimDecimalIfZero = true }: FormatPriceOptions = {}
) => {
  // Move from a amount with cents included to the regular price
  const priceInFull = value / 100
  const fullPrice = safeguardNumberFormat(
    priceInFull,
    currency,
    trimDecimalIfZero
  )

  return fullPrice
}
